import { BaseService } from "./base.service";
import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { CertificateNew, CertificateResponse } from "../models/certificate.model";
import { SassCertificatesModel } from "../models/sassCertificate.model";
import { SupportContextService } from "./support-context.service";

@Injectable({
  providedIn: "root"
})
export class CertificateService extends BaseService {
  className = "CertificateService";

  constructor(injector: Injector, private supportContext: SupportContextService) {
    super(injector);
  }

  addNewCertificate(isReadDataFromSassEnabled: boolean, model: CertificateNew): Observable<CertificateResponse> {
    if (isReadDataFromSassEnabled) {
      const url = this.supportContext.accountId 
        ? `/v2/certificate?accountId=${this.supportContext.accountId}`
        : '/v2/certificate';
      return this.postAny<CertificateResponse>(url, model);
    }
    return this.postAny<CertificateResponse>('/v1/certificate', model);
  }

  deleteCertificate(certificateGuid: string): Observable<object> {
    return this.delete(`/v2/certificates/${certificateGuid}`);
  }

  getCurrentAccountCertificates(): Observable<SassCertificatesModel> {
    const params = this.supportContext.accountId ? { accountId: this.supportContext.accountId } : {};
    return this.get<SassCertificatesModel>(`/v2/certificates/current`, params);
  }
}